import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as dayjs from 'dayjs';
import { ISpeech } from 'src/interfaces/speech.interface';
import {
  editingSpeech,
  editSpeech,
  removeSpeech,
  setActiveSpeech,
} from 'src/store/actions/speech.action';
import { isEmpty } from 'src/utils/isEmpty';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-view-speeches',
  templateUrl: './view-speeches.component.html',
  styleUrls: ['./view-speeches.component.css'],
})
export class ViewSpeechesComponent implements OnInit {
  authors$: Array<string> = [];
  speeches: ISpeech[] = [];
  currentSpeech: ISpeech | null = null;
  editing: boolean = false;
  author: string = '';
  keywords: string = '';
  dateCreated: string = '';

  constructor(private store: Store<any>) {
    this.store.select('speech').subscribe((data) => {
      this.speeches = data.data;
      this.currentSpeech = isEmpty(data.currentSpeech)
        ? null
        : {
            ...data.currentSpeech,
            date: dayjs(data?.currentSpeech?.date).format('MMM DD, YYYY'),
          };

      this.editing = data.editing;
      this.authors$ = data.authors;
    });
  }

  ngOnInit(): void {}

  setSpeech(obj: ISpeech) {
    this.store.dispatch(
      setActiveSpeech({
        obj,
      })
    );
  }

  onDelete() {
    Swal.fire({
      title: 'Are you sure you want to delete this speech?',
      showDenyButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('Speech Deleted', '', 'success');
        this.store.dispatch(removeSpeech());
      }
    });
  }

  onEdit() {
    this.store.dispatch(editingSpeech());
  }

  onSave() {
    const response = this.getProps();

    if (response) {
      this.store.dispatch(editSpeech(response));
    }
  }

  getProps() {
    const obj: any = {};
    const title = document.getElementById('title')?.innerText;
    const content = document.getElementById('content')?.innerText;

    if (!title) {
      Swal.fire('Empty Title is not allowed', '', 'error');
      return false;
    }

    if (!content) {
      Swal.fire('Empty Content is not allowed', '', 'error');
      return false;
    }

    obj.title = title;
    obj.content = content;

    if (this.author) {
      obj.author = this.author;
    }

    if (this.keywords) {
      obj.keywords = this.keywords;
    }

    if (this.dateCreated) {
      obj.date = this.dateCreated;
    }

    return obj;
  }

  async onShare() {
    const { value: email } = await Swal.fire({
      title: 'Enter email address',
      input: 'email',
      inputLabel: 'Your email address',
      inputPlaceholder: 'Enter your email address',
    });

    if (email) {
      Swal.fire(`Speech sent to: ${email}`, '', 'success');
    }
  }
}
